export default __webpack_public_path__ + "static/triggers-nl-34ace45e0e5e019a8d3f1de9e82a5b31.png";